// extracted by mini-css-extract-plugin
export default {"skeleton":"lB6jPvbNO_EqqDQSBV1L"};